import { type SbBlokData, storyblokEditable } from '@storyblok/react/rsc'

/**
 * seoSchemaJsonLD Storyblok block
 * Provides per-page SEO metadata and JSON-LD schema injection
 *
 * Storyblok Asset fields return objects with a filename property.
 * OgImage is an Asset field type, not a plain URL string.
 */
interface SeoSchemaJsonLDProps {
  blok: {
    JsonSchema: string // JSON-LD schema to inject as <script type="application/ld+json">
    Title: string // Fallback meta/og title when seo.title is empty
    OgImage: { filename: string } // Asset field for social share image (og:image)
  } & SbBlokData
}

export default function SeoSchemaJsonLD({ blok }: SeoSchemaJsonLDProps) {
  return <div {...storyblokEditable(blok)} />
}
